module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_9006.b7f0b474.png";